import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'
import { optionalEnrollmentId } from '@utils/optionalEnrollmentId'

const HAS_PREVIOUS_AVAILABLE_LESSON = gql`
  query HasPreviousAvailableLesson($currentLessonId: ID!, $enrollmentId: ID) {
    previousAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
    }
  }
`

export const useHasPreviousAvailableLesson = (
  currentLessonId: number,
  /** Ausente na visão do produtor: não existe matrícula. */
  enrollmentId?: number | string | null,
) => {
  const [hasPreviousAvailableLesson, { loading, error }] = useLazyQuery(
    HAS_PREVIOUS_AVAILABLE_LESSON,
    {
      variables: {
        currentLessonId,
        enrollmentId: optionalEnrollmentId(enrollmentId),
      },
      // Disponibilidade pode mudar sem troca de aula (progresso linear,
      // lockAt/releaseAt); cache-first devolveria o resultado antigo.
      fetchPolicy: 'network-only',
    },
  )

  return { hasPreviousAvailableLesson, loading, error } as {
    hasPreviousAvailableLesson: (
      currentLessonId: number,
      enrollmentId?: number | string | null,
    ) => Promise<QueryResult<{ previousAvailableLesson: { id: number } }>>
    loading: boolean
    error: ApolloError
  }
}
